/**
 * Convert a string into a slug:
 * - normalize unicode (é → e)
 * - lowercase
 * - trim whitespace
 * - replace spaces with hyphens
 * - strip out non-word characters
 * - collapse multiple hyphens
 */
export function slugify(text) {
  return text
    .toString() // ensure we’re working with a string
    .normalize("NFKD") // split accents from letters
    .replace(/[\u0300-\u036F]/g, "") // remove accent marks
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-") // spaces → hyphens
    .replace(/[^\w-]/g, "") // remove all non-word chars
    .replace(/--+/g, "-"); // collapse multiple hyphens
}
